/** @format */

import { PlkField } from './PlkTypesInterface';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import { PlusOrdersCommonResponse } from '../../interfaces/platform/PlusOrdersCommonResponse';
import { DateHelper } from '../../helpers/DateHelper';
import { DateHelperTs } from '../../helpers/DateHelperTs';

const _ = require('underscore');
const XMLParser = require('react-xml-parser');

export default class SetClientDefault {
    protected operation: MvnoOperation;

    constructor(operation: MvnoOperation) {
        this.operation = operation;
    }

    getRequestParameter = (index: number): Array<PlkField> => {
        let request = this.getPlusOrdersCommonResponse(index);
        let obj: Array<PlkField> = [];
        if (!this.operation.tableResponse[index].requestQuery) {
            return obj;
        }
        const xml = new XMLParser().parseFromString(this.operation.tableResponse[index].requestQuery);
        const dataParams = xml.getElementsByTagName('DATA');
        if (dataParams && dataParams[0]) {
            const dataParam = dataParams[0];
            const childern = dataParam['children'];
            _.map(childern, (val: { name: string; value: string | number }, key: string) => {
                obj.push({ key: val.name, value: val.value });
            });
        } else {
            _.map(JSON.parse(this.operation.eventsJson), (val: string, key: string) => {
                if (key === 'DATE') {
                    val = DateHelperTs.reformatDate(request.createdAt, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD');
                }
                if (key === 'TIME') {
                    val = DateHelperTs.reformatDate(request.createdAt, 'YYYY-MM-DD HH:mm:ss', 'HH:mm');
                }
                obj.push({ key: key, value: val });
            });
        }
        obj = _.sortBy(obj, 'key');
        obj.unshift({ key: 'createdAt', value: DateHelper.format(request.createdAt) });
        return obj;
    };

    getResponseParameter = (index: number): Array<PlkField> => {
        let obj: Array<PlkField> = [];
        const response = this.getPlusOrdersCommonResponse(index);
        obj.push({ key: 'responseTime', value: DateHelper.format(response.responseTime) });
        const responseJsonObject = JSON.parse(response.messageJson);
        _.map(responseJsonObject, (val: string, key: string) => {
            if (key !== 'XML_RESPONSE' && key !== 'XML_REQUEST') {
                if (key !== 'items') {
                    obj.push({ key: key, value: val });
                } else {
                    let items: Array<PlkField> = [];
                    for (let i = 0; i < val.length; i++) {
                        _.map(val[i], (v1: string, k1: string) => {
                            items.push({ key: k1, value: v1 });
                        });
                    }
                    obj.push({ key: key, value: items });
                }
            }
        });
        return obj;
    };

    getPlusOrdersCommonResponse = (index: number): PlusOrdersCommonResponse => {
        return this.operation.tableResponse[index];
    };
}
